var News = function() {

	this.init = function() {

		this.Slider();

	}

	this.Slider = function(){

		$('[data-component="news"] .div-to-slide').slick({
			arrows: false,
			slidesToShow: 1,
			centerMode: true,
			centerPadding: '0px',
			responsive: [
				{
					breakpoint: 768,
					settings: {
						arrows: false,
						centerMode: true,
						centerPadding: '0px'
					}
				}
			]
		});

		$('[data-component="news"] a[data-slide]').click(function(e) {
			e.preventDefault();
			var slideno = $(this).data('slide');
			$('[data-component="news"] .div-to-slide').slick('slickGoTo', slideno);
			$(this).siblings().removeClass("current");
			$(this).addClass("current");
		});

		$('.div-to-slide').on('beforeChange', function(event, slick, currentSlide, nextSlide){
		  var slideNum = nextSlide;
		  $('[data-component="pagination"] a').each(function(){
		  	var currentData = $(this).data('slide');
		  	if(currentData == slideNum){
		  		$('[data-component="pagination"] a').removeClass('current');
		  		$(this).addClass('current');
		  	}
		  })
		});

	}

	return this.init();

}
